import styled from 'styled-components'

export const PageWrapper = styled.div``
export const TitleWrapper = styled.div``
export const OptionsWrapper = styled.div``
export const OptionWrapper = styled.div``
export const OptionSwitchWrapper = styled.div``
export const OptionDescriptionWrapper = styled.div``
